<div class="row justify-content-center align-items-center" mat-dialog-title>
    <div class="col-md-10 col-10">
        <h5 class="text-left txt-primario">Pagos & Recuperaciones - {{this.siniestroBase}}</h5>
    </div>
    <div class="col-md-2 col-2 text-right">
        <i (click)="closeDialog('Cancelar')" class="fas fa-times icon-close"></i>
    </div>
</div>
<mat-dialog-content class="py-0">
    <mat-tab-group #pagosReferencias (selectedTabChange)="onTabChange($event)" [selectedIndex]="tabIndex"
        mat-stretch-tabs="true" mat-align-tabs="center" color="primary">
        <mat-tab *ngFor="let opcion of catTabsPagosRecuperaciones " [label]="opcion"
            [disabled]="opcion.id != this.detalleSiniestro.responsabilidad ">
            <ng-template mat-tab-label>
                {{opcion.nombre}}
            </ng-template>

            <div class="contenedor-panel" [ngSwitch]="opcion.id">
                <app-crear-actualizar-pagos-recuperaciones
                    [datosPagosRecuperaciones]="opcion.id != this.detalleSiniestro.responsabilidad ? [] : listaPagosRecuperaciones"
                    [seccion]="opcion.id" (eventosPagosRecuperaciones)="procesaEventoPagosRecuperaciones($event)">
                </app-crear-actualizar-pagos-recuperaciones>
            </div>
        </mat-tab>
    </mat-tab-group>
</mat-dialog-content>